import React, { useState, useEffect } from 'react';

const Loader = ({
    size = 'large',
    fullScreen = true,
    message = 'Loading...',
    delay = 50 // Reduced delay so it responds much faster
}) => {
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoader(true);
        }, delay);
        return () => clearTimeout(timer);
    }, [delay]);

    const sizeClasses = {
        small: 'w-6 h-6 border-2',
        medium: 'w-10 h-10 border-[3px]',
        large: 'w-12 h-12 border-4'
    };

    if (!showLoader) {
        return <div className={fullScreen ? "min-h-[60vh]" : "py-10"} />; 
    }

    // SMALL LOADER (For buttons or small widgets inside the page)
    if (!fullScreen) {
        return (
            <div className="flex flex-col items-center justify-center py-10 w-full">
                <div className={`${sizeClasses[size]} border-slate-200 border-t-primary-600 rounded-full animate-spin mb-3`}></div>
                <p className="text-gray-500 text-sm">{message}</p>
            </div>
        );
    }

    // ✅ FULL SCREEN DATA LOADER (For pages fetching API data)
    // We add a dark strip at the top so the transparent navbar text remains visible!
    return (
        <div className="w-full min-h-[70vh] flex flex-col items-center relative">
            
            {/* Dark strip locked to the top of the screen under the navbar */}
            <div className="absolute top-0 left-0 right-0 h-[100px] bg-slate-900 z-0 w-full"></div>
            
            <div className="flex-grow flex flex-col items-center justify-center pt-32 relative z-10 w-full">
                <div className="mb-6">
                    <img
                        src="/images/logo.png"
                        alt="Logo"
                        className="h-12 mx-auto opacity-40 grayscale"
                        onError={(e) => { e.target.style.display = 'none'; }}
                    />
                </div>
                
                <div className={`${sizeClasses[size]} border-slate-200 border-t-primary-600 rounded-full animate-spin mb-4 shadow-sm`}></div>
                
                <p className="text-slate-700 font-semibold tracking-wide text-lg">{message}</p>
                <p className="text-slate-400 text-sm mt-1">Fetching data...</p>
            </div>
        </div>
    );
};

export default Loader;